// assets/quiz-review.js

/// <reference path="./types.js" />

const quizDataDemo = {
    "domainKnowledge": "Outdoor education is organized learning that takes place in the outdoors, such as during school camping trips. Outdoor education programs sometimes involve residential or journey wilderness-based experiences which engage participants in a variety of adventurous challenges and outdoor activities such as hiking, climbing, canoeing, ropes courses and group games. Outdoor education draws upon the philosophy, theory, and practices of experiential education and environmental education. Outdoor education has diverse goals and practices, but is often described as learning about, in, and through the outdoors. Outdoor education can be defined as experiential learning in, for, or about the outdoors. The term 'outdoor education', however, is used broadly to refer to a range of organized activities that take place in a variety of ways in predominantly outdoor environments. Common definitions of outdoor education are difficult to achieve because interpretations vary according to culture, philosophy, and local conditions. Outdoor education is often referred to as synonymous with outdoor learning, outdoor school, forest schools and wilderness education. Outdoor education often uses or draws upon related elements and/or informs related areas, such as teaching students how to pitch tents and cook over a campfire. The hallmark of outdoor education is its focus on the 'outdoor' side of this education; whereas adventure education would focus on the adventure side and environmental education would focus on environmental. Expeditionary education involves expeditions into wilderness 'where man is but a visitor.' All of these activities typically involve experiential education.",
    "difficulty": 6,
    "shorthandSummary": "Topics covered: Outdoor education, experiential learning, outdoor activities.",
    "questionsWAnswers": [
        {
            "id": "6945d31d763d3f087da688cd",
            "question": "Which of the following is NOT commonly associated with outdoor education?",
            "options": {
                "a": "Climbing",
                "b": "Hiking",
                "c": "Standardized testing"
            },
            "correctAnswer": "c",
            "explanation": "Outdoor education is primarily focused on practical activities like hiking and climbing, unlike standardized testing which is a method of assessing academic knowledge in a classroom setting."
        },
        {
            "id": "6945d31d763d3f087da688ce",
            "question": "How does outdoor education integrate with environmental education?",
            "options": {
                "a": "By focusing on interaction with and understanding of the natural environment.",
                "b": "By promoting indoor theoretical discussions about the environment.",
                "c": "By teaching survival skills in abandoned buildings."
            },
            "correctAnswer": "a",
            "explanation": "Outdoor education often incorporates environmental education by engaging students in direct experiences that promote awareness and understanding of ecological concepts through hands-on learning in natural settings."
        },
        {
            "id": "6945d31d763d3f087da688cf",
            "question": "What is a defining characteristic of outdoor education?",
            "options": {
                "a": "It focuses solely on classroom-based learning.",
                "b": "It emphasizes experiential learning in outdoor environments.",
                "c": "It occurs exclusively indoors."
            },
            "correctAnswer": "b",
            "explanation": "Outdoor education is characterized by its focus on learning experiences that take place outside the traditional classroom, emphasizing hands-on activities and engagement with the natural environment."
        },
        {
            "id": "6945d31d763d3f087da688d0",
            "question": "What is NOT a defining characteristic of outdoor education?",
            "options": {
                "a": "It focuses solely on classroom-based learning.",
                "b": "It emphasizes experiential learning in outdoor environments.",
                "c": "It includes interaction with nature."
            },
            "correctAnswer": "a",
            "explanation": "Outdoor education is characterized by its focus on learning experiences that take place outside the traditional classroom, emphasizing hands-on activities and engagement with the natural environment."
        }
    ],
    "subject": "Outdoor Education",
    "id": "69430aebad7ccecd63052692"
};

const dialog = document.getElementById("quizReviewDialog");
// if (!dialog) return;

const elSubject = document.getElementById("qrSubject");
const elSummary = document.getElementById("qrSummary");
const elQuestions = document.getElementById("qrQuestions");

const tplCard = /** @type {HTMLTemplateElement} */ (document.getElementById("qrQuestionCardTpl"));
const tplAnswer = /** @type {HTMLTemplateElement} */ (document.getElementById("qrAnswerRowTpl"));

const btnCancel = document.getElementById("qrCancelBtn");
const btnConfirm = document.getElementById("qrConfirmBtn");

let currentQuiz = null;
let currentTaskId = null;
let currentOnConfirm = null;
let currentOnCancel = null;

function clearQuestions() {
  while (elQuestions.firstChild) elQuestions.removeChild(elQuestions.firstChild);
}

/** options expected: { a: "...", b: "...", c: "..." }
 * @return in stable order a,b,c
 * */
function normalizeOptions(options) {
    const keys = ["a", "b", "c"];
    return keys
        .filter((k) => options && typeof options[k] === "string")
        .map((k) => ({ key: k, text: options[k] }));
}

function renderQuiz(quiz) {
    btnConfirm.textContent = SK.tMsg("frontend.ai_quiz.confirmContinue");
    clearQuestions();
    const subject = quiz?.subject || "—";
    const summary = quiz?.shorthandSummary || "";

    elSubject.textContent = subject;
    elSummary.textContent = summary;

    const qas = Array.isArray(quiz?.questionsWAnswers) ? quiz.questionsWAnswers : [];
    qas.forEach((q, index) => {
        console.log("[quiz-review::renderQuiz] Rendering question:", q);
        const cardFrag = /** @type {DocumentFragment} */ (tplCard.content.cloneNode(true));
        const cardEl = /** @type {HTMLElement} */ (cardFrag.querySelector(".qr-card"));
        cardEl.dataset.questionId = String(q.id);

        const qnoEl = cardFrag.querySelector("[data-qno]");
        const qTextEl = cardFrag.querySelector("[data-question]");
        const answersEl = cardFrag.querySelector("[data-answers]");
        const actionSelect = /** @type {HTMLSelectElement} */ (cardFrag.querySelector("[data-action]"));

        qnoEl.textContent = `Q${index + 1}`;
        qTextEl.textContent = q?.question || "—";

        // default action is KEEP
        actionSelect.value = ACTION.KEEP;
        actionSelect.addEventListener("sl-change", () => {
            // nothing else needed for now; we read values on submit
            const selectedAction = actionSelect.value;
            console.log(`[quiz-review::renderQuiz] Question ${index} action changed to:`, selectedAction);
            /** @type {RegenerateAction[]} */
            const decisions = collectUserDecisions();
            // if any different from KEEP, change the confirm button text to indicate regeneration:
            const anyChange = decisions.some(d => d.action !== ACTION.KEEP);
            if (anyChange) {
                btnConfirm.textContent = SK.tMsg("frontend.ai_quiz.regenerateQuiz");
            } else {
                btnConfirm.textContent = SK.tMsg("frontend.ai_quiz.confirmContinue");
            }
            // TODO: mark it visually: greater opacity
        });

      // Answers
      const options = normalizeOptions(q?.options);
      const correct = String(q?.correctAnswer || "").toLowerCase();

      options.forEach((opt) => {
        const ansFrag = /** @type {DocumentFragment} */ (tplAnswer.content.cloneNode(true));
        const row = ansFrag.querySelector(".qr-answer");
        const cb = /** @type {HTMLInputElement} */ (ansFrag.querySelector("sl-checkbox"));
        const text = ansFrag.querySelector("[data-answer-text]");

        text.textContent = opt.text;
        const isCorrect = opt.key === correct;
        if (isCorrect) {
          row.classList.add("correct");
          // show it as “checked”, but disabled (read-only UI)
          cb.checked = true;
        } else {
          cb.checked = false;
        }

        answersEl.appendChild(ansFrag);
      });

        elQuestions.appendChild(cardFrag);
    });
}

/** @returns {RegenerateAction[]} */
function collectUserDecisions() {
  // returns array same length as questions
  const cards = elQuestions.querySelectorAll(".qr-card");
  /** @type {RegenerateAction[]} */
  const decisions = [];

  cards.forEach((card) => {
    const questionId = /** @type {HTMLElement} */ (card).dataset.questionId;
    const select = /** @type {HTMLSelectElement} */ (card.querySelector('sl-select[data-action]'));
    const action = /** @type {RegenerateActionType} */ (select?.value || ACTION.KEEP);

    decisions.push({
      questionId: String(questionId),
      action, // "keep" | "avoid" | "improve"
    });
  });
  return decisions;
}

async function handleConfirm() {
  if (!currentQuiz) return;

  /** @type {RegenerateAction[]} */
  const decisions = collectUserDecisions();

  /** @type {QuizRegeneratePayload} */
  const payload = {
    taskId: currentTaskId,
    no_of_questions: currentQuiz.questionsWAnswers.length,
    difficulty_level: currentQuiz.difficulty,
    subject: currentQuiz.subject,
    actions: decisions
  };

  dialog.hide();

  // if caller provided onConfirm, call it
  if (typeof currentOnConfirm === "function") {
    await currentOnConfirm(payload, currentQuiz);
  }
}

/**
 * Opens the quiz review dialog with provided quiz data.
 * @param {string} taskId
 * @param {object} quizData
 * @param {object} opts
 * @param {function} [opts.onConfirm] - optional callback when user confirms; receives (payload, quizData)
 * @param {function} [opts.onCancel] - optional callback when user cancels
 */
function openQuizReview(taskId, quizData = quizDataDemo, opts = {}) {
  console.log("[quiz-review::openQuizReview] Opening quiz review with quizData:", quizData);
  currentQuiz = quizData;
  currentTaskId = taskId;
  currentOnConfirm = opts.onConfirm || null;
  currentOnCancel = opts.onCancel || null;

  renderQuiz(quizData);
  dialog.show();
}

dialog.addEventListener("sl-request-close", (event) => {
    const reason = /** @type {CustomEvent} */ (event).detail?.source; 
    console.log("[quiz-review::dialog::sl-request-close] Close requested, reason:", reason);
  // source is typically: 'overlay' | 'keyboard' | 'close-button'

    if (reason === 'overlay' || reason === 'keyboard') {
        event.preventDefault(); // block outside click + ESC
    }
});

async function handleCancel() {
  console.log("[quiz-review::handleCancel] Closing quiz review dialog");
  dialog.hide();

  // if caller provided onCancel, call it
  if (typeof currentOnCancel === "function") {
    await currentOnCancel();
  }
}

function submitQuizReview() {
  /** @type {RegenerateAction[]} */
  const decisions = [...document.querySelectorAll("sl-select")]
    .map(el => ({
      questionId: /** @type {HTMLElement} */ (el).dataset.questionId,
      action: /** @type {RegenerateActionType} */ (/** @type {HTMLSelectElement} */ (el).value)
    }));

  console.log("Quiz decisions:", decisions);

  // !TODO: POST to Node.js backend
}

btnCancel.addEventListener("click", handleCancel);
btnConfirm.addEventListener("click", handleConfirm);